import { ContainerType } from "src/app/enum/enum";

export class containerResponse {
  id: number = 0;
  companyId: number = 0;
  storeId: number = 0;
  referenceNumber: string = '';
  description: string = '';
  type: number = ContainerType.Unknown;
  status: number = 0;
  createdAt: string = '';
  externalId: string = '';
  isLablePrint?: boolean = false;
}
export class containerRequestModel {
  id?: number = 0;
  companyId: number = 0;
  storeId: number = 0;
  referenceNumber: string = '';
  description: string = '';
  type: number = ContainerType.Unknown;
  status: number = 0;
  externalId: string = '';
}
